"use client";
import HttpErrorMessage from "@components/errors/HttpErrorMessage";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { Flex } from "@ui/components/layout/flex/Flex";

export default function NotFoundClient() {
    const { getMultiple } = useMicrocopy();
    const microcopies = getMultiple(CommonCMS.shared, [
        CommonCMS.error.headlineFourOhFour,
        CommonCMS.error.textFourOhFour,
    ]);

    return (
        <Flex>
            <div hidden aria-hidden="true" data-testid="http404" />
            <HttpErrorMessage
                headline={microcopies[CommonCMS.error.headlineFourOhFour]}
                text={microcopies[CommonCMS.error.textFourOhFour]}
                errorCode={404}
            />
        </Flex>
    );
}
